module.exports = __webpack_public_path__ + "static/media/Fladnicka.05e31d5d.md";